<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div v-for="(property, index) in testator.properties" :key="index">
        <div class="list-item">
          <v-btn
            class="list-item-btn property-list-item-btn"
            :ripple="false"
            block
            color="white"
            @click.stop="(showDialog = true), (propertyToUpdate = property)"
          >
            <div class="list-item-text">
              <span class="list-item-name pl-0">{{
                property.physicalAddress
              }}</span>
              <span class="list-item-separator">-</span>
              <span v-if="ownership(property)" class="list-item-more-info">{{
                ownership(property)
              }}</span>
              <v-icon v-else class="pl-2" large color="red">{{
                icons.mdiHelpCircle
              }}</v-icon>
              <span
                v-if="
                  property.ownership == 'CO_OWN' ||
                  property.ownership == 'CO_OWN_WITH_SPOUSE'
                "
                class="pa-0"
              >
                <span class="list-item-separator">-</span>
                <span
                  v-if="percentageShare(property)"
                  class="list-item-more-info"
                  >{{ percentageShare(property) }}</span
                >
                <v-icon v-else class="pl-2" large color="red">{{
                  icons.mdiHelpCircle
                }}</v-icon>
              </span>
            </div>
          </v-btn>
        </div>
      </div>
      <div class="mt-5 mb-5">
        <AlternativeButton
          :title="'Add Property'"
          @gradientButtonClicked="addPropertyClicked"
        />
      </div>
    </v-col>
    <PropertyDialog
      v-model="showDialog"
      :property-to-update="propertyToUpdate"
      :testator="testator"
    />
  </v-row>
</template>

<script>
  import PropertyDialog from './PropertyDialog.vue';

  export default {
    name: 'PropertiesList',
    components: {
      PropertyDialog,
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        showDialog: false,
        propertyToUpdate: {},
      };
    },
    methods: {
      addPropertyClicked() {
        this.propertyToUpdate = {};
        this.showDialog = true;
        this.sendGADataLayer('add-property');
      },
      sendGADataLayer(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: event,
          omuserid: this.$store.getters?.userId,
        });
      },
      ownership(property) {
        switch (property.ownership) {
          case 'SOLE_OWN':
            return 'sole owner';
          case 'CO_OWN_WITH_SPOUSE':
            return 'co-own with spouse';
          case 'CO_OWN':
            return 'co-own';
          case 'SPOUSE_SOLE_OWNER':
            return 'spouse is the sole owner';
          default:
            return null;
        }
      },
      percentageShare(property) {
        return property.percentageShare ? property.percentageShare + '%' : null;
      },
    },
  };
</script>
